import { routeTree } from './routes';
import { FC, PropsWithChildren } from 'react';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { getRequired } from '@excent-one/config';

export const router = createRouter({
  routeTree,
  basepath: getRequired('VITE_APP_BASE_PATH'),
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const AppRoutes: FC<PropsWithChildren> = () => {
  return <RouterProvider router={router} />;
};

export default AppRoutes;
